import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, Transition as _Transition } from "vue";
const _hoisted_1 = {
  class: "min-h-[100vh] bg-gray-950 flex flex-col md:flex-row md:justify-center"
};
const _hoisted_2 = {
  class: "flex-1 md:max-w-[35rem] pt-6"
};
const _hoisted_3 = {
  class: "text-white font-mono text-4xl font-bold ml-4 mt-4 mr-4 flex flex-col"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-11/12 h-[0.1rem] bg-white mt-3 mb-2"
}, null, -1);
const _hoisted_6 = {
  class: "font-normal text-xl mb-4"
};
const _hoisted_7 = {
  class: "text-2xl"
};
const _hoisted_8 = {
  class: "text-base font-normal text-gray-400"
};
const _hoisted_9 = {
  class: "relative"
};
const _hoisted_10 = ["disabled"];
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-r-2 peer-disabled:opacity-50 peer-disabled:pointer-events-none"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "scale-75 mr-2 opacity-65 i-mdi-rename"
})], -1);
const _hoisted_12 = {
  class: "text-2xl mt-4 mb-1"
};
const _hoisted_13 = {
  class: "text-base font-normal text-gray-400 mb-2"
};
const _hoisted_14 = {
  class: "text-2xl mt-4 mb-1"
};
const _hoisted_15 = {
  class: "text-base font-normal text-gray-400"
};
const _hoisted_16 = {
  class: "relative flex mt-2 text-white"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = {
  key: 0,
  class: "text-xl"
};
const _hoisted_19 = {
  class: "text-2xl mt-1 mb-1"
};
const _hoisted_20 = {
  class: "text-base font-normal text-gray-400 mb-5"
};
const _hoisted_21 = ["disabled"];
const _hoisted_22 = {
  class: "flex items-center mb-1 mt-6 justify-between"
};
const _hoisted_23 = {
  class: "text-2xl"
};
const _hoisted_24 = {
  class: "text-base font-normal text-gray-400 mb-1"
};
const _hoisted_25 = {
  class: "flex"
};
const _hoisted_26 = {
  class: "relative flex-1"
};
const _hoisted_27 = ["disabled"];
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "absolute inset-y-0 start-0 flex items-center pointer-events-none ps-r-2 peer-disabled:opacity-50 peer-disabled:pointer-events-none"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-internet scale-75 mr-2 opacity-65"
})], -1);
const _hoisted_29 = {
  class: "flex items-center"
};
const _hoisted_30 = {
  key: 0,
  class: "text-xl ml-3"
};
const _hoisted_31 = {
  class: "inline-flex items-center text-xl mt-4"
};
const _hoisted_32 = {
  class: "relative flex items-center p-3 rounded-full cursor-pointer",
  htmlFor: "check"
};
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3.5 w-3.5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "1"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
})])], -1);
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  class: "mt-px font-light text-gray-300 cursor-pointer select-none",
  htmlFor: "check"
}, " Create Invite Link ", -1);
const _hoisted_35 = {
  class: "flex text-xl flex-col space-y-1"
};
const _hoisted_36 = {
  class: "inline-flex items-center"
};
const _hoisted_37 = {
  class: "relative flex items-center p-3 rounded-full cursor-pointer",
  htmlFor: "check"
};
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3.5 w-3.5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "1"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
})])], -1);
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", {
  class: "mt-px font-light text-gray-300 cursor-pointer select-none",
  htmlFor: "check"
}, " Revoke Mint Token ", -1);
const _hoisted_40 = {
  class: "inline-flex items-center"
};
const _hoisted_41 = {
  class: "relative flex items-center p-3 rounded-full cursor-pointer",
  htmlFor: "check"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", {
  class: "absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
}, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3.5 w-3.5",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": "1"
}, [/*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
  "clip-rule": "evenodd"
})])], -1);
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "mt-px font-light text-gray-300 cursor-pointer select-none",
  htmlFor: "check"
}, " Revoke Freeze Account ", -1);
const _hoisted_44 = {
  class: "text-red-600 text-xl mt-6"
};
const _hoisted_45 = ["disabled"];
const _hoisted_46 = {
  class: "flex-1 md:max-w-[30rem] text-white font-mono flex flex-col text-xl p-6 space-y-3"
};
const _hoisted_47 = {
  class: "text-3xl font-bold mt-4"
};
const _hoisted_48 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_51 = {
  class: "text-3xl font-bold mt-4"
};
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_53 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_61 = {
  class: "text-pink-700"
};
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_63 = {
  class: "text-pink-700"
};
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_65 = {
  class: "text-pink-700"
};
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_67 = {
  key: 0,
  class: "fixed font-mono z-10 left-0 top-0"
};
const _hoisted_68 = {
  class: "bg-[#5b5b5b70] w-[100vw] h-[100vh] sticky pt-0 flex justify-center"
};
const _hoisted_69 = {
  style: {
    "box-shadow": "0 8px 20px rgba(0,0,0,.6)"
  },
  class: "bg-slate-950 rounded-2xl w-[28rem] md:w-[40rem] h-[60vh] md:h-[24rem] top-[20vh] md:top-[20vh] relative shadow-md flex flex-col items-center overflow-y-auto pb-2"
};
const _hoisted_70 = {
  class: "w-5/6 text-center pt-4 flex item-center flex-col"
};
const _hoisted_71 = {
  class: "h-[3rem] w-full pt-3 flex justify-between items-center mb-8"
};
const _hoisted_72 = {
  class: "text-2xl text-white mr-4"
};
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", {
  class: "i-mdi-close"
}, null, -1);
const _hoisted_74 = [_hoisted_73];
const _hoisted_75 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-white text-left mb-6"
}, [/*#__PURE__*/_createTextVNode(" This is the only private key for accessing the token you created."), /*#__PURE__*/_createElementVNode("br")], -1);
const _hoisted_76 = {
  class: "flex items-center space-x-3 mb-6"
};
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 i-mdi-clipboard"
}, null, -1);
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", {
  class: "mr-1 i-mdi-scan"
}, null, -1);
const _hoisted_79 = {
  class: "w-full bg-slate-600 mb-6 flex justify-center items-center hidden-key"
};
const _hoisted_80 = {
  class: "m-4",
  style: {
    "word-wrap": "anywhere",
    "overflow-wrap": "anywhere"
  }
};
const _hoisted_81 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-white text-left"
}, " Please keep it in a safe place, as it will be the sole credential for create more token! ", -1);
import { createToken } from '@/wallets';
import { useStore } from '@/store';
import { ref } from 'vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { copyTextToClipBoard } from '@/utils';
import { checkInvitionExistByPubkey, putInvitionData } from '@/invite';
export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {
    const {
      t
    } = useI18n(); // use as global scope
    const store = useStore();
    const show_result_model = ref(false);
    const show_meta_model = ref(false);
    const choose_dec = ref(5);
    const token_name = ref("");
    const supply = ref(1000);
    const token_uri = ref("");
    const symbol = ref("");
    const error_msg = ref("");
    const result_key = ref("");
    const revoke_mint_token = ref(false);
    const revoke_freeze_account = ref(false);
    const create_delegate = ref(false);
    const invite_code = ref("");
    const meta_forms = ref({
      image: "",
      description: "",
      extension_keys: ["Twitter", "Website", "Telegram"],
      extension_values: ["", "", ""],
      tags: ["meme", "HODL", "mintheToken"],
      creator: {
        name: "",
        site: ""
      },
      now_input_tag: ""
    });
    function wrongFormInput() {
      error_msg.value = "";
      let has_error = false;
      if (!store.activate_wallet || !store.activate_wallet.adapter.publicKey) {
        error_msg.value = t('errors.noWalletAvailable');
        return true;
      }
      if (token_name.value == "" || !/^[a-zA-Z0-9]+$/.test(token_name.value)) {
        error_msg.value += t('errors.tokenNameInvalid');
        has_error = true;
      }
      if (symbol.value == "" || !/^[a-zA-Z0-9]+$/.test(symbol.value)) {
        error_msg.value += t('errors.tokenSymbolInvalid');
        has_error = true;
      }
      if (supply.value <= 0) {
        error_msg.value += t('errors.supplyMustBeGreaterThanZero');
        has_error = true;
      }
      return has_error;
    }
    async function clickCreate() {
      if (wrongFormInput() || !store.activate_wallet) {
        return;
      }
      invite_code.value = "";
      store.mint_running = true;
      const pubkey = store.activate_wallet.adapter.publicKey;
      if (!pubkey) {
        return;
      }
      if (create_delegate.value) {
        let result_last_code = await checkInvitionExistByPubkey(pubkey.toBase58());
        if (result_last_code != '') {
          create_delegate.value = false;
          invite_code.value = result_last_code;
        }
      }
      try {
        let result = await createToken(store.activate_wallet, {
          token_name: token_name.value,
          supply: supply.value,
          url: token_uri.value,
          decimals: choose_dec.value,
          symbol: symbol.value,
          revoke_mint_tokens: revoke_mint_token.value,
          revoke_freeze_account: revoke_freeze_account.value,
          create_delegate: create_delegate.value
        });
        console.log(result);
        result_key.value = result;
        show_result_model.value = true;
      } catch (e) {
        error_msg.value = t('errors.creationError', {
          tokenName: token_name.value,
          errorMessage: e.toString()
        });
      }
      try {
        if (create_delegate.value) {
          invite_code.value = await putInvitionData({
            pubkey: pubkey === null || pubkey === void 0 ? void 0 : pubkey.toBase58(),
            id_byte: 10
          });
        }
      } catch {}
      store.mint_running = false;
    }
    function useTestForm() {
      token_name.value = "MikuCoin";
      supply.value = 198964;
      token_uri.value = "https://bafkreihdbiktzcxcgk2w5rlqanwiiegn6pdlwhhkev7nezhlkhayhik6fq.ipfs.dweb.link/";
      symbol.value = "MIK";
    }
    function isValidIpfsUrl(url) {
      const regex = /^https:\/\/brown-big-mackerel-960\.mypinata\.cloud\/ipfs\/[a-z2-7]{59}$/;
      return regex.test(url);
    }
    async function clickUploadMetadata() {
      if (isValidIpfsUrl(token_uri.value)) {
        let req = await axios({
          method: 'get',
          url: token_uri.value
        });
        if (req.data) {
          try {
            if (req.data.description) {
              meta_forms.value.description = req.data.description;
            }
            if (req.data.image) {
              meta_forms.value.image = req.data.image;
            }
            if (req.data.extensions) {
              meta_forms.value.extension_keys = Object.keys(req.data.extensions);
              meta_forms.value.extension_values = Object.values(req.data.extensions);
            }
            if (req.data.creator && Object.keys(req.data.creator).length > 0) {
              if (req.data.creator.name) {
                meta_forms.value.creator.name = req.data.creator.name;
              }
              if (req.data.creator.site) {
                meta_forms.value.creator.site = req.data.creator.site;
              }
            }
          } catch {}
        }
      }
      show_meta_model.value = true;
    }
    function goSolScan() {
      window.open(`https://solscan.io/token/${result_key.value}`);
    }
    return (_ctx, _cache) => {
      const _component_SolanaLogo = _resolveComponent("SolanaLogo");
      const _component_LetterInput = _resolveComponent("LetterInput");
      const _component_FlodableContainer = _resolveComponent("FlodableContainer");
      const _component_LoadingIcon = _resolveComponent("LoadingIcon");
      const _component_LinkShow = _resolveComponent("LinkShow");
      const _component_MetadataEditor = _resolveComponent("MetadataEditor");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_SolanaLogo, {
        class: "h-[3rem]"
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('titles.solanaTokenCreator')), 1)]), _hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('descriptions.solanaTokenCreator')), 1), _unref(store).debug ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "underline text-pink-500 cursor-pointer text-xl",
        onClick: useTestForm
      }, _toDisplayString(_ctx.$t('actions.debugUseTestForm')), 1)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('labels.tokenName')), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('hints.tokenName')), 1), _createElementVNode("div", _hoisted_9, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => token_name.value = $event),
        disabled: _unref(store).mint_running,
        class: "peer py-3 pe-0 ps-10 block w-full bg-transparent border-t-transparent border-b-2 border-x-transparent border-b-gray-600 text-base focus:border-t-transparent focus:border-x-transparent focus:border-b-white focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 dark:focus:border-b-gray-600"
      }, null, 8, _hoisted_10), [[_vModelText, token_name.value]]), _hoisted_11]), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("labels.tokenSymbol")), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("hints.tokenSymbol")), 1), _createVNode(_component_LetterInput, {
        "input-length": "10",
        disabled: _unref(store).mint_running,
        modelValue: symbol.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => symbol.value = $event)
      }, null, 8, ["disabled", "modelValue"]), _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("labels.tokenDecimals")), 1), _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("hints.tokenDecimals")), 1), _createElementVNode("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3, 4, 5, 6, 7, 8, 9], i => {
        return _createElementVNode("div", {
          onClick: $event => _unref(store).mint_running ? () => {} : (() => {
            choose_dec.value = i;
          })(),
          class: _normalizeClass(["flex-1 hover:mt-0 cursor-pointer flex flex-col justify-center items-center", i === choose_dec.value ? 'text-white' : 'text-gray-500 hover:text-gray-200 underline mt-1 hover:mt-0'])
        }, [_createTextVNode(_toDisplayString(i) + " ", 1), i === choose_dec.value ? (_openBlock(), _createElementBlock("span", _hoisted_18, "▲")) : _createCommentVNode("", true)], 10, _hoisted_17);
      }), 64))]), _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t("labels.tokenSupply")), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("hints.tokenSupply")), 1), _withDirectives(_createElementVNode("input", {
        type: "number",
        disabled: _unref(store).mint_running,
        id: "number-input",
        "aria-describedby": "helper-text-explanation",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => supply.value = $event),
        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-0 focus:ring-blue-500 focus:border-blue-500 block w-11/12 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
        required: ""
      }, null, 8, _hoisted_21), [[_vModelText, supply.value]]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("labels.tokenMetadataURI")), 1)]), _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("hints.tokenMetadataURI")), 1), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => token_uri.value = $event),
        disabled: _unref(store).mint_running,
        class: "peer py-3 pe-0 ps-10 block w-full bg-transparent border-t-transparent border-b-2 border-x-transparent border-b-gray-600 text-base focus:border-t-transparent focus:border-x-transparent focus:border-b-white focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-gray-700 dark:text-gray-400 dark:focus:ring-gray-600 dark:focus:border-b-gray-600"
      }, null, 8, _hoisted_27), [[_vModelText, token_uri.value]]), _hoisted_28]), _createElementVNode("div", _hoisted_29, [!isValidIpfsUrl(token_uri.value) ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.$t("nouns.or")), 1)) : _createCommentVNode("", true), _createElementVNode("button", {
        onClick: clickUploadMetadata,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors ml-5 h-full text-lg flex px-2"
      }, [_createElementVNode("span", {
        class: _normalizeClass(["mr-1", !isValidIpfsUrl(token_uri.value) ? 'i-mdi-upload' : 'i-mdi-edit'])
      }, null, 2), _createTextVNode(" " + _toDisplayString(!isValidIpfsUrl(token_uri.value) ? _unref(t)("actions.upload") : _unref(t)("actions.edit")) + " " + _toDisplayString(_unref(t)("nouns.metadata")), 1)])])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("label", _hoisted_32, [_withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => create_delegate.value = $event),
        class: "before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-700 checked:before:bg-gray-900 hover:before:opacity-10",
        id: "check"
      }, null, 512), [[_vModelCheckbox, create_delegate.value]]), _hoisted_33]), _hoisted_34]), _createVNode(_component_FlodableContainer, {
        class: "mt-8 pt-3",
        title: "Advacned Options"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("label", _hoisted_37, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => revoke_mint_token.value = $event),
          class: "before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-700 checked:before:bg-gray-900 hover:before:opacity-10",
          id: "check"
        }, null, 512), [[_vModelCheckbox, revoke_mint_token.value]]), _hoisted_38]), _hoisted_39]), _createElementVNode("div", _hoisted_40, [_createElementVNode("label", _hoisted_41, [_withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => revoke_freeze_account.value = $event),
          class: "before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:bg-gray-700 checked:before:bg-gray-900 hover:before:opacity-10",
          id: "check"
        }, null, 512), [[_vModelCheckbox, revoke_freeze_account.value]]), _hoisted_42]), _hoisted_43])])]),
        _: 1
      }), _createElementVNode("span", _hoisted_44, _toDisplayString(error_msg.value), 1), _createElementVNode("button", {
        disabled: _unref(store).mint_running,
        onClick: clickCreate,
        class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-2 px-4 rounded items-center mt-3 w-full transition-colors"
      }, [_createVNode(_component_LoadingIcon, {
        loading: _unref(store).mint_running
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t("actions.createToken", {
          tokenSymbol: symbol.value
        })), 1)]),
        _: 1
      }, 8, ["loading"])], 8, _hoisted_45)])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("article.tokenCreatorDesc.title")), 1), _hoisted_48, _createElementVNode("span", null, _toDisplayString(_ctx.$t("article.tokenCreatorDesc.para1")), 1), _hoisted_49, _createElementVNode("span", null, _toDisplayString(_ctx.$t("article.tokenCreatorDesc.para2")), 1), _hoisted_50, _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("article.tokenCreatorUsage.title")), 1), _hoisted_52, _createElementVNode("span", null, _toDisplayString(_ctx.$t("article.tokenCreatorUsage.desc")), 1), _hoisted_53, _createElementVNode("span", null, [_createTextVNode("1. "), _createElementVNode("span", {
        class: "text-pink-600 underline cursor-pointer",
        onClick: _cache[7] || (_cache[7] = $event => _unref(store).show_wallet_model = true)
      }, _toDisplayString(_ctx.$t("nouns.connect")), 1), _createTextVNode(" " + _toDisplayString(_ctx.$t("nouns.yourWallet")) + ".", 1)]), _hoisted_54, _createElementVNode("span", null, "2." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para2")), 1), _hoisted_55, _createElementVNode("span", null, "3." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para3")), 1), _hoisted_56, _createElementVNode("span", null, "4." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para4")), 1), _hoisted_57, _createElementVNode("span", null, "5." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para5")), 1), _hoisted_58, _createElementVNode("span", null, "6." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para6")), 1), _hoisted_59, _createElementVNode("span", null, "7." + _toDisplayString(_ctx.$t("article.tokenCreatorUsage.para7")), 1), _hoisted_60, _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t("article.tokenCreatorUsage.foot1")), 1), _hoisted_62, _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("article.tokenCreatorUsage.foot2")), 1), _hoisted_64, _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.$t("article.tokenCreatorUsage.foot3")), 1), _hoisted_66])]), _createVNode(_Transition, {
        name: "fade"
      }, {
        default: _withCtx(() => [show_result_model.value ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$t('messages.wellDoneCreateToken', {
          symbol: symbol.value
        })), 1), _createElementVNode("div", {
          onClick: _cache[8] || (_cache[8] = $event => show_result_model.value = false),
          class: "absolute right-[2rem] h-[1.5rem] w-[1.5rem] bg-[#1c2338] rounded-[50%] scale-[1.5] flex justify-center items-center text-slate-400 hover:text-slate-200 cursor-pointer transition-colors"
        }, _hoisted_74)]), _hoisted_75, _createElementVNode("div", _hoisted_76, [_createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = $event => _unref(copyTextToClipBoard)(result_key.value)),
          class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"
        }, [_hoisted_77, _createTextVNode(" Copy to Clipborad ")]), _createElementVNode("button", {
          onClick: goSolScan,
          class: "bg-gray-300 hover:bg-pink-600 hover:text-white text-gray-800 font-bold py-1 rounded items-center transition-colors h-full text-lg flex px-2"
        }, [_hoisted_78, _createTextVNode(" Go SolScan ")])]), _createElementVNode("div", _hoisted_79, [_createElementVNode("span", _hoisted_80, _toDisplayString(result_key.value), 1)]), _hoisted_81, _createVNode(_component_LinkShow, {
          show: invite_code.value != '',
          invite_code: invite_code.value
        }, null, 8, ["show", "invite_code"])])])])])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_MetadataEditor, {
        token_name: token_name.value,
        "onUpdate:token_name": _cache[10] || (_cache[10] = $event => token_name.value = $event),
        symbol: symbol.value,
        "onUpdate:symbol": _cache[11] || (_cache[11] = $event => symbol.value = $event),
        meta_forms: meta_forms.value,
        "onUpdate:meta_forms": _cache[12] || (_cache[12] = $event => meta_forms.value = $event),
        token_uri: token_uri.value,
        "onUpdate:token_uri": _cache[13] || (_cache[13] = $event => token_uri.value = $event),
        show_model: show_meta_model.value,
        "onUpdate:show_model": _cache[14] || (_cache[14] = $event => show_meta_model.value = $event)
      }, null, 8, ["token_name", "symbol", "meta_forms", "token_uri", "show_model"])], 64);
    };
  }
});